import {useEffect, useState, useRef} from "react";
import {useSelector} from "react-redux";
import {DashboardHeader} from "../../components/dashboard-header";
import {CustomerSideNav} from "../../components/dashboard-sidebar copy";
import {RootState} from "../../redux/store";
import {useLocation} from "react-router-dom";
import {
  DashboardContainer,
  DashboardHeaderContainer,
  DashboardMainContainer,
  StyledMainSectionContainer,
  StyledMainSectionInnerContainer,
} from "./dashboard-wrapper.style";
import {Helmet} from "react-helmet-async";
import {useNavigate} from "react-router-dom";

declare const window: Window &
  typeof globalThis & {
    Intercom: any;
    heap: any;
  };

interface IDashboardWrapper {
  children: React.ReactNode;
  pageTitle: string;
  pageDesc?: string;
  pageSlug?: string;
}

const CustomerDashboardWrapper: React.FC<IDashboardWrapper> = ({
  children,
  pageTitle,
  pageDesc,
  pageSlug,
}) => {
  const {userInfo} = useSelector((state: RootState) => state.userLogin);
  const {activeContext, isContextSwitching} = useSelector(
    (state: RootState) => state.userContext
  );
  const location = useLocation();
  const [showNav, setShowNav] = useState(false);
  const navigate = useNavigate();
  const originalBodyOverflow = useRef<string>("");

  const toggle = () => {
    setShowNav(!showNav);
  };

  const currentContext = activeContext || (userInfo?.isCustomer ? "customer" : "coach");

  useEffect(() => {
    if (userInfo) {
      if (currentContext === "coach" && location.pathname.startsWith("/customer")) {
        navigate("/home");
        return;
      }
      if (currentContext === "customer" && !location.pathname.startsWith("/customer")) {
        navigate("/customer/home");
        return;
      }
    }
  }, [currentContext, location.pathname, navigate, userInfo, isContextSwitching]);

  // useEffect(() => {
  //   if (
  //     userInfo &&
  //     userInfo.user &&
  //     userInfo.user.emailAddress &&
  //     userInfo.user.firstName &&
  //     userInfo.user.lastName
  //   ) {
  //     const email = userInfo.user.emailAddress.toLowerCase();
  //     const name = `${userInfo.user.firstName} ${userInfo.user.lastName}`;

  //     if (window.heap) {
  //       window.heap.identify(`${email}: ${name}`);
  //       window.heap.addUserProperties({
  //         name: name,
  //         email: email,
  //         user_id: email,
  //       });
  //     }

  //     if (window.Intercom) {
  //       window.Intercom("boot", {
  //         api_base: "https://api-iam.intercom.io",
  //         app_id: "lhv6fa0p",
  //         name: name,
  //         email: email,
  //         user_id: email,
  //         created_at: userInfo.user.createdAt,
  //       });
  //     }
  //   }
  // }, [userInfo]);

  useEffect(() => {
    if (originalBodyOverflow.current === "") {
      originalBodyOverflow.current = document.body.style.overflow || "";
    }

    const isMobileView = window.innerWidth <= 960;

    const handleResize = () => {
      const isMobile = window.innerWidth <= 960;
      if (!isMobile) {
        document.body.style.overflow = originalBodyOverflow.current;
      } else if (showNav) {
        document.body.style.overflow = "hidden";
      }
    };

    if (showNav && isMobileView) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = originalBodyOverflow.current;
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.body.style.overflow = originalBodyOverflow.current;
    };
  }, [showNav]);

  return (
    <>
      <Helmet>
        <title>Coachli | {pageTitle ?? "Do more with Coachli"} </title>
        <meta
          name="description"
          content={
            pageDesc ||
            "The simplest way to host paid 1:1 calls with your clients, mentees and audience."
          }
        />
        <link rel="canonical" href={pageSlug} />
        <meta property="og:url" content={pageSlug} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDesc} />
        <meta property="og:image:width" content="" />
        <meta property="og:image:height" content="" />
        {/* <meta property="og:image" content={image} />
            <meta name="og:image" content={image} /> */}
        <meta property="og:type" content="website" />
        <meta charSet="utf-8" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDesc} />
        {/* <meta property="twitter:image" content={image} /> */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:image:alt" content="Coachli Logo" />
        <meta name="twitter:site" content="" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:url" content={pageSlug} />
      </Helmet>

      <DashboardContainer>
        {/* <DashboardSideBarContainer> */}
        {/* <DashboardSidebar toggleNav={toggle} visible={showNav} close={toggle} /> */}
        <CustomerSideNav toggleNav={toggle} visible={showNav} />
        {/* </DashboardSideBarContainer> */}
        <DashboardMainContainer>
          <DashboardHeaderContainer>
            <DashboardHeader toggleNav={toggle} />
          </DashboardHeaderContainer>
          <StyledMainSectionContainer>
            <StyledMainSectionInnerContainer>{children}</StyledMainSectionInnerContainer>
          </StyledMainSectionContainer>
        </DashboardMainContainer>
      </DashboardContainer>
    </>
  );
};

export {CustomerDashboardWrapper};
